module.exports = __webpack_public_path__ + "static/media/gifIcon.3261feb2.svg";